export default "__VITE_ASSET__CIOe87u9__"